import React, { useCallback } from 'react'
import { Route, Switch } from 'react-router'
import { useHistory } from 'react-router-dom'
import { Tabs } from 'antd'
import { Panel } from '../../../core/components/styled'
import { useLastPathnameSegment } from '../../../common/hooks/router'
import ScrapingTestCaseManagementPage from './scraping-test-case-management-page'
import ScrapingTestCaseDistributionPage from './scraping-test-case-distribution-page'

const ScrapingTestCasesPage = () => {
  const history = useHistory()
  const currentTab = useLastPathnameSegment()

  const handleChangeTab = useCallback(
    tabKey => history.push(`/scraping/test-cases/${tabKey}`),
    [history],
  )

  return (
    <>
      <Panel margin="small no no no">
        <Tabs type="card" activeKey={currentTab} onChange={handleChangeTab}>
          <Tabs.TabPane tab="Test case management" key="management" />
          <Tabs.TabPane tab="Test case distribution" key="distribution" />
        </Tabs>
      </Panel>

      <Switch>
        <Route
          path="/scraping/test-cases/management"
          component={ScrapingTestCaseManagementPage}
        />
        <Route
          path="/scraping/test-cases/distribution"
          component={ScrapingTestCaseDistributionPage}
        />
      </Switch>
    </>
  )
}
export default ScrapingTestCasesPage
